import {useSubscribeToNotificationsQuery} from '@dms/api/appsync';
import {useListSentToastNotificationsQuery} from '@dms/api/core';

import {isDefinedNonZeroValue} from 'shared/web';

import {isHiddenRuleNotification} from '../utils/isHiddenRuleNotification';

export function useNotifications(pageSize: number) {
  const {data, refetch, isLoading, isFetching, isError} = useListSentToastNotificationsQuery(
    {
      limit: pageSize,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  useSubscribeToNotificationsQuery((notification) => {
    if (notification.variant === 'toast') {
      refetch();
    }
  });

  // Counted from what the list shows: a rule notification the orchestration flag hides must not
  // leave a badge nobody can clear one by one.
  const unreadNotificationsCount = data?.notifications?.filter(
    (notification) => !notification.isRead && !isHiddenRuleNotification(notification.type)
  ).length;
  const hasUnreadNotifications = isDefinedNonZeroValue(unreadNotificationsCount);

  return {
    data,
    isLoading,
    isFetching,
    isError,
    hasUnreadNotifications,
    unreadNotificationsCount,
  };
}
